import { gtmEventHandler } from '@common/utils/gtm';

export const trackingMissingDetailsForm = (e, inputId, elClass) => {
  const elementsToTrack = document.getElementsByClassName(elClass);
  const totalInputFields = elementsToTrack.length;
  const currentIndex = Array.from(elementsToTrack).findIndex(
    (el) => el.id === inputId,
  );

  const filledInputs = Array.from(elementsToTrack).filter(
    (el) => el.value,
  ).length;
  const totalFilledInputs = `${filledInputs}/${totalInputFields}`;

  gtmEventHandler(
    'cta',
    `input_field_${currentIndex + 1}`,
    'click',
    'alumni_directory',
    {
      click_text: inputId,
      click_item: totalFilledInputs,
      click_position: currentIndex,
      click_type: 'form-fields',
    },
  );
};

export const trackingSubmitMissingDetails = (status, message) => {
  gtmEventHandler(
    'cta',
    'missing_details_form',
    'click',
    'alumni_directory',
    {
      form_status: status,
      message,
    },
  );
};

export const trackingQnAForm = (e, idx, questions) => {
  gtmEventHandler(
    'cta',
    `question_field_${idx + 1}`,
    'click',
    'alumni_directory',
    {
      click_item: `${questions.length}/2`,
      click_position: idx,
      click_text: e.target.id,
      click_type: 'form-fields',
    },
  );
};

export const trackingSubmitQnAForm = (status, message) => {
  gtmEventHandler(
    'cta',
    'qna_form',
    'click',
    'alumni_directory',
    {
      form_status: status,
      message,
    },
  );
};
